export default __webpack_public_path__ + "images/gif1.1609ed.gif";